// OpenTelemetry web tracing: clicks + fetch/XHR become spans and inject the W3C
// `traceparent` header into backend calls so frontend and backend share one trace.
// No-op unless an OTLP endpoint is configured.
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { API_BASE_URL } from "./config";

const otlpUrl =
  (window._env_ && window._env_.REACT_APP_OTEL_EXPORTER_URL) ||
  process.env.REACT_APP_OTEL_EXPORTER_URL;

const environment =
  (window._env_ && window._env_.REACT_APP_OTEL_ENVIRONMENT) ||
  process.env.REACT_APP_OTEL_ENVIRONMENT ||
  "local"; // dev / production -> filter in SigNoz

if (otlpUrl) {
  const user = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}");
  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      "service.name": "certbuddy-frontend",
      "deployment.environment": environment,
      "user.id": user.user_id || "anonymous",
      "org.id": user.org_id || "",
    }),
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter({ url: otlpUrl }))],
  });
  provider.register({ contextManager: new ZoneContextManager() });

  // Inject traceparent only on backend calls (cross-origin :3000 -> :8000).
  const propagateTo = [new RegExp(API_BASE_URL.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))];
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        "@opentelemetry/instrumentation-fetch": { propagateTraceHeaderCorsUrls: propagateTo },
        "@opentelemetry/instrumentation-xml-http-request": {
          propagateTraceHeaderCorsUrls: propagateTo,
        },
      }),
    ],
  });
}
